import {
  InGameCurrency,
  ManagerProgressionTaskState,
} from '@sorare/core/src/__generated__/globalTypes';
import { useConfigContext } from '@sorare/core/src/contexts/config';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useEnabledWheelByRarity } from '@sorare/core/src/hooks/useEnabledWheelByRarity';

export const useWheelTickets = (
  { excludeCommonTickets }: { excludeCommonTickets: boolean } = {
    excludeCommonTickets: false,
  }
) => {
  const { currentUser } = useCurrentUserContext();
  const enabledWheels = useEnabledWheelByRarity();
  const {
    wheel: { tasks },
    so5: { dailyTasksExpiresAt },
  } = useConfigContext();
  const task = tasks[0];
  const ticketCount =
    currentUser?.wheelTickets
      ?.filter(
        x =>
          (enabledWheels.limited &&
            (x.currency === InGameCurrency.WHEEL_TICKET ||
              x.currency === InGameCurrency.GOLDEN_WHEEL_TICKET)) ||
          (!excludeCommonTickets &&
            enabledWheels.common &&
            (x.currency === InGameCurrency.COMMON_WHEEL_TICKET ||
              x.currency === InGameCurrency.COMMON_GOLDEN_WHEEL_TICKET))
      )
      ?.reduce((acc, cur) => acc + cur.amount, 0) ?? 0;
  const ticketAvailable =
    task?.aasmState === ManagerProgressionTaskState.COMPLETED;
  const canBeDisplayed = dailyTasksExpiresAt && task?.id;
  const canClaimTicket = canBeDisplayed && ticketAvailable;

  return {
    canClaimTicket,
    ticketCount,
  };
};
